import { createContext } from "react";

interface UIContextData {
  success(): void;
}

export const UIContext = createContext<UIContextData>({} as UIContextData);
